import styled from 'styled-components';

export const OverlayImage = styled.img`
    height: 300px;
    width: auto;
`;
